import type { LearnerExam } from "../content-schema";
import { previewModules, previewRouteOptions, previewSections, routeLabel, sectionLabel } from "../question-presentation/exam-preview";

export function ExamRouteControls({ modules, routes, onChange }: {
  modules: LearnerExam["modules"];
  routes: Record<string, string>;
  onChange: (section: string, moduleId: string) => void;
}) {
  const selected = previewModules(modules, routes);
  if (!previewSections.some(section => previewRouteOptions(modules, section).length)) return null;
  return <div className="exam-route-controls" role="group" aria-label="Preview routes">
    {previewSections.map(section => {
      const options = previewRouteOptions(modules, section);
      return options.length ? <label key={section}>{sectionLabel(section)} Module 2
        <select value={selected.find(m => m.section === section && m.stage === 2)?.id} onChange={event => onChange(section, event.target.value)}>
          {options.map(module => <option key={module.id} value={module.id}>{routeLabel(module.routeBand)} route</option>)}
        </select>
      </label> : null;
    })}
    <p>Choose a route to preview its questions. Students are routed automatically during the test.</p>
  </div>;
}
